/* eslint-disable no-console */
import { useEffect, useRef } from 'react';

/**
 * Hook específico para manejar el evento onCallEnd del SDK de Fonema.
 *
 * - Cierra la UI y libera disponibilidad cuando la llamada actual termina.
 */
const useFonemaOnCallEnd = ({ callInfoData, onClose, enabled = true }) => {
  const callInfoDataRef = useRef(callInfoData);
  const onCloseRef = useRef(onClose);
  callInfoDataRef.current = callInfoData;
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!enabled) return undefined;

    let unsubscribeCallEnd;

    if (window.FonemaWhatsappAudio?.onCallEnd) {
      console.log('Subscribing to onCallEnd event (useFonemaOnCallEnd)');
      unsubscribeCallEnd = window.FonemaWhatsappAudio.onCallEnd((callId) => {
        console.log('Call ended:', callId, callInfoDataRef.current);
        if (callInfoDataRef.current?.callId === callId) {
          if (typeof window.clearFonemaCallReferences === 'function') {
            window.clearFonemaCallReferences();
          }
          if (typeof onCloseRef.current === 'function') {
            onCloseRef.current(callId);
          }
        }
      });
    }

    return () => {
      console.log('Cleaning up onCallEnd listener in useFonemaOnCallEnd');
      if (unsubscribeCallEnd && typeof unsubscribeCallEnd === 'function') {
        console.log('Unsubscribing from onCallEnd event');
        unsubscribeCallEnd();
      }
    };
  }, [onCloseRef, callInfoDataRef, enabled]);
};

export default useFonemaOnCallEnd;
